var React = require('react');

function IconText (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512.9 757.9v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h428.1c5.5 0 10 4.5 10 10zM960.9 571.9v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10zM960.9 385.9v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10zM960.9 199.9v67c0 5.5-4.5 10-10 10H74.8c-5.5 0-10-4.5-10-10v-67c0-5.5 4.5-10 10-10h876.1c5.5 0 10 4.5 10 10z"}));
}

IconText.displayName = "IconText";

IconText.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconText;

IconText.default = IconText;
